import { useQuery } from '@tanstack/react-query';

import { cleanObjectEmptyFields } from '@hero/utils';

import { services } from '../../services';

export const useGetAutomations = (params = {}, options = {}) => {
  const {
    filters: { searchTerm = '', status = '', type = '', createdBy = '' } = {},
    pagination: { page = 1, limit } = {}
  } = params || {};

  return useQuery(
    ['automations', searchTerm, status, type, page, limit, createdBy],
    () => services.list(cleanObjectEmptyFields(params)),
    {
      staleTime: 60 * 1000,
      refetchOnMount: false,
      ...options
    }
  );
};
